var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.563,
    height: 14.867,
    viewBox: "0 0 11.563 14.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete",
    "data-name": "Icon material-delete",
    d: "M8.326,17.715a1.657,1.657,0,0,0,1.652,1.652h6.608a1.657,1.657,0,0,0,1.652-1.652V7.8H8.326ZM19.063,5.326H16.173L15.347,4.5h-4.13l-.826.826H7.5V6.978H19.063Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#8da7be"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.05188a2ab1b05a087a31d34d72e07034.svg";
export { ForwardRef as ReactComponent };